import {createAction} from 'redux-actions';

const createDashboardCommand = <T>(type: string) => createAction<T>('_C/DB/' + type);

export interface FetchDashboardDataPayload {
    month?: string;
}

export interface FetchEmployeeRateListPayload {
}

export interface FetchYearlyRevenuePayload {
    year?: number;
}

export interface SetEmployeeDefaultRatePayload {
    userId: string;
    hourlyRate: number;
}

export interface SetProjectEmployeeRatePayload {
    projectId: string;
    userId: string;
    hourlyRate: number;
}

const DashboardCommand = {
    fetchDashboardData: createDashboardCommand<FetchDashboardDataPayload>('FETCH_DASHBOARD_DATA'),
    fetchYearlyRevenue: createDashboardCommand<FetchYearlyRevenuePayload>('FETCH_YEARLY_REVENUE'),
    fetchEmployeeRateList: createDashboardCommand<FetchEmployeeRateListPayload>('FETCH_EMPLOYEE_RATE_LIST'),
    setEmployeeDefaultRate: createDashboardCommand<SetEmployeeDefaultRatePayload>('SET_EMPLOYEE_DEFAULT_RATE'),
    setProjectEmployeeRate:
        createDashboardCommand<SetProjectEmployeeRatePayload>('SET_PROJECT_EMPLOYEE_RATE'),
};

export default DashboardCommand;
